'use strict';

var Promise = require('./core.js')
var asap = require('asap')

module.exports = Promise
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this
  self.then(null, function (err) {
    asap(function () {
      throw err
    })
  })
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/promise/lib/done.js
 ** module id = 258
 ** module chunks = 0
 **/